
import { api_host } from '../../common/globals/constants';


export function getCardOrder() {
    return new Promise((resolve, reject) => {
        let user_id = sessionStorage.getItem('user')
        let token = sessionStorage.getItem('key')
        let start = new Date().getTime()
        fetch(api_host + `/reporte/online/indicadores/getFavoritesOrder/?user=${user_id}&token=${token}&start=${start}`)
            .then(response => response.json())
            .then(cardOrder => {
                if (cardOrder == "No existen usuario en tabla.") {
                    resolve(null)
                }
                let favorites_order = JSON.parse(cardOrder.favorites_order)
                resolve(favorites_order)
            })
            .catch(error => {
                reject(error);
            });
    })
}

export function updateFavoritesOrder(orderCards) {
    let user_id = sessionStorage.getItem('user')
    let token = sessionStorage.getItem('key')
    let start = new Date().getTime()
    fetch(api_host + `/reporte/online/indicadores/updateFavoritesOrder/?user=${user_id}&token=${token}&orden_favoritos=${orderCards}&start=${start}`)
        .then(response => response.json())
}